import { useLanguage } from "../../../../contexts/LanguageContext"

/**
 * Main modal footer component.
 * Renders the modal footer with action buttons and conditional "Powered by" text.
 * @param {Object} props
 * @param {Object} props.parameters - Configuration parameters for "Powered by" display
 * @returns {JSX.Element}
 */
export default function ModalFooter({ parameters }) {
  const { t } = useLanguage()

  return (
    <div className="shortwaysDrag modal-footer">
      <button type="button" id="mainPopupDesignerFile" className="btn btnDesigner" title="Shortways Designer" data-form-type="action" data-testid="mainPopupDesignerFile" />
      <button type="button" id="mainPopupSettingsFile" className="btn btnAdminSettings" title="Administration Settings" data-form-type="other" data-testid="mainPopupSettingsFile" />
      {parameters?.displayPoweredBy && <span className="powered-by">{t("AssistantWindow.assistantWindowPoweredBy")}</span>}
    </div>
  )
}
